const lines = '==========================================================================';
const line  = '--------------------------------------------------------------------------';
global.delay = function(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}
global.invalidBoolean = function(bool) {
    return bool !== false && bool !== true;
};

global.toStrEql = function(str1, str2, permitNullStr = false) {
    let string_1 = str1 + ''
    let string_2 = str2 + ''
    let result = string_1 === string_2
    if(permitNullStr === false) {
        result = result === true && !invalidString(string_1) && !invalidString(string_2)
    }
    return result
}
global.invalidString = function(str, permitNullStr = false) {
    let invalid = false;
    if(undefinedOrNull(str, permitNullStr)) {
        invalid = true;
    } else {
        let isString = typeof str === 'string' || (typeof str === 'object' && typeof str.valueOf() === 'string');
        if(!isString) {
            invalid = true;
        } else if (str === "") {
            invalid = true;
        }
    }
    return invalid;
};

global.undefinedOrNull = function(foo, permitNullStr = true) {
    let strNull = (foo !== undefined && foo !== null) && (foo === 'null' || foo === 'NULL' || foo === 'Null') && permitNullStr === false
    return foo === undefined || foo === null || strNull === true;
};

global.cgetVarInfo = function(name, v){
    let vclass;
    let vvalue;
    if (v === undefined){
        vclass = 'Undefined';
        vvalue = '';
    } else if (v === null) {
        vclass = 'Null';
        vvalue = '';
    } else {
        vclass = v.constructor.name;
        vvalue = v;
    }
    let vname = undefinedOrNull(name) ? 'variable' : name;
    return vname + '(' + vclass + ')' + ' = ' + vvalue;
};

global.cgetJsonInfo = function(name, json){
    let info;
    if(!undefinedOrNull(name) && !undefinedOrNull(json)){
        info = name + '(' + json.constructor.name + ')' + ' = ' + JSON.stringify(json);
    } else {
        info = name + '(Undefined or Null)';
    }
    return info;
};

global.cjump = function() {
    console.log();
};

global.cclear = function() {
    console.clear();
};

global.error = function(msg, ...params) {
    console.error(msg, params);
};

global.cwarn = function(msg, ...params) {
    console.warn(msg, params);
};

global.clog = function(value, name = null, json = true) {
    let detail
    if(name === null || name === undefined || name === '') {
        detail = value;
    } else {
        detail = json === true ? cgetVarInfo(name, value) : cgetJsonInfo(name, value);
    }
    console.log(detail);
};
global.jump = function() {
    console.log();
};

global.cline = function() {
    clog(line);
};

global.clines = function() {
    clog(lines);
};

global.cclog = function(value, color, weight, name = null, json = true) {
    let detail;
    if(invalidString(name)) {
        detail = json === false ? value : JSON.stringify(value);
    } else {
        detail = json === false ? cgetVarInfo(name, value) : cgetJsonInfo(name, value);
    }
    console.log("%c" + detail, "color:" + color + ";font-weight:"+weight+";");
};

global.cgreen = function(value, name = null, json = true) {
    cclog(value, 'green', 'bold', name, json);
}
global.cred = function(value, name = null, json = true) {
    cclog(value, 'red', 'bold', name, json);
}
global.cblue = function(value, name = null, json = true) {
    cclog(value, 'blue', 'bold', name, json);
}
global.cyellow = function(value, name = null, json = true) {
    cclog(value, 'yellow', 'bold', name, json);
}
global.ccyan = function(value, name = null, json = true) {
    cclog(value, 'cyan', 'bold', name, json);
}

global.ctitle = function(value, color, name = null, json = true) {
    cclog(lines, color, 'bold', name, false);
    cclog(value, color, 'bold', name, json);
    cclog(lines, color, 'bold', name, false);
};
global.cgreent = function(value, name = null, json = true) {
    cgreen(line);
    cgreen(value, name, json);
    cgreen(line);
}
global.credt = function(value, name = null, json = true) {
    cred(line);
    cred(value, name, json);
    cred(line);
}
global.cbluet = function(value, name = null, json = true) {
    cblue(line);
    cblue(value, name, json);
    cblue(line);
}
global.cyellowt = function(value, name = null, json = true) {
    cyellow(line);
    cyellow(value, name, json);
    cyellow(line);
}
global.ccyant = function(value, name = null, json = true) {
    ccyan(line);
    ccyan(value, name, json);
    ccyan(line);
}

// $(document).on('turbolinks:load', function () {
//     function ctitle(msg) {
//         if(!undefinedOrNull(msg)) {
//             clines();
//             clog(msg);
//             clines();
//         }
//     };
//     function csubtitle(msg) {
//         if(!undefinedOrNull(msg)) {
//             cline();
//             clog(msg);
//             cline();
//         }
//     };
//
//     function clogic(logic, detail = null, trueIsError = true, printOnlyError = false) {
//         if (booleanTrue(trueIsError)) {
//             if (booleanTrue(logic)) {
//                 cred(logic, detail, false);
//             } else if(booleanFalse(printOnlyError)) {
//                 cgreen(logic, detail, false);
//             }
//         } else {
//             if (booleanTrue(logic) && booleanFalse(printOnlyError)) {
//                 cgreen(logic, detail, false);
//             } else {
//                 cred(logic, detail, false);
//             }
//         }
//     }
//
//     function cgreenl(value, name = null, json = true) {
//         cgreen(line);
//         cgreen(value, name, json);
//     }
//     function credl(value, name = null, json = true) {
//         cred(line);
//         cred(value, name, json);
//     }
//     function cbluel(value, name = null, json = true) {
//         cblue(line);
//         cblue(value, name, json);
//     }
//     function cyellowl(value, name = null, json = true) {
//         cyellow(line);
//         cyellow(value, name, json);
//     }
//     function ccyanl(value, name = null, json = true) {
//         ccyan(line);
//         ccyan(value, name, json);
//     }
//
//     function cgreenj(value, name = null, json = true) {
//         cjump();
//         cgreen(value, name, json);
//     }
//     function credj(value, name = null, json = true) {
//         cjump();
//         cred(value, name, json);
//     }
//     function cbluej(value, name = null, json = true) {
//         cjump();
//         cblue(value, name, json);
//     }
//     function cyellowj(value, name = null, json = true) {
//         cjump();
//         cyellow(value, name, json);
//     }
//     function ccyanj(value, name = null, json = true) {
//         cjump();
//         ccyan(value, name, json);
//     }
// });
